var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/settings"}},[_vm._v("Settings")]),_c('UiTab',{attrs:{"to":"/settings/referral"}},[_vm._v("Referral")]),_c('UiTab',{attrs:{"to":"/settings/history"}},[_vm._v("History")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }